import React, { useState } from 'react';
import { IconButton, Tooltip, FormControlLabel, Switch } from '@mui/material';
import './ButtonGrid.css';
import { iconVariants } from './IconVariants';

interface ButtonGridProps {
  onButtonSelect: (iconType: string, iconStyle: 'filled' | 'outlined') => void;
  selectedIcon?: string;
  iconStyle?: 'filled' | 'outlined';
  color?: string;
  backgroundColor?: string;
}

const ButtonGrid: React.FC<ButtonGridProps> = ({
  onButtonSelect,
  selectedIcon,
  iconStyle = 'filled',
  color,
  backgroundColor,
}) => {
  const [isOutlined, setIsOutlined] = useState(iconStyle === 'outlined');

  const iconButtons = iconVariants.map((icon) => ({
    type: icon.type,
    icon: isOutlined ? icon.outlined : icon.filled,
    label: icon.label,
  }));

  return (
    <div className="button-grid-container">
      <div className="button-grid-header">
        <FormControlLabel
          control={
            <Switch
              checked={isOutlined}
              onChange={() => {
                setIsOutlined((prev) => !prev);
                onButtonSelect(selectedIcon || '', !isOutlined ? 'outlined' : 'filled');
              }}
            />
          }
          label={isOutlined ? 'Outlined' : 'Filled'}
          sx={{
            '& .MuiFormControlLabel-label': {
              color: color,
            },
          }}
        />
      </div>
      <div className="button-grid ">
        {iconButtons.map((btn) => (
          <Tooltip
            title={btn.label}
            key={btn.type}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <IconButton
              className="grid-button"
              onClick={() => onButtonSelect(btn.type, isOutlined ? 'outlined' : 'filled')}
              size="large"
              sx={{
                background: selectedIcon === btn.type ? '#e0f7fa' : '#f5f5f5',
                border: selectedIcon === btn.type ? '2px solid #00bcd4' : '1px solid transparent',
                '&:hover': {
                  background: selectedIcon === btn.type ? '#b2ebf2' : '#e0f7fa',
                },
                '& svg': {
                  color: selectedIcon === btn.type ? '#00838f' : '#555',
                  width: '20px',
                  height: '20px',
                },
              }}
            >
              {btn.icon}
            </IconButton>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

export default ButtonGrid;
